module.exports = __webpack_public_path__ + "static/media/3.bec55603.svg";